import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import SearchForScanner from './SearchForScanner';

const mapStateToProps = (state: RootState) => ({
    pageToRender: state.SearchContainer.pageToRender
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SearchForScanner);
